import { render } from "./Upload.vue?vue&type=template&id=612bef27&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=612bef27&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-612bef27"

export default script